// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as TailwindMerge from "tailwind-merge";
import IcoCarSvg from "./outline/ico-car.svg";
import IcoChatSvg from "./outline/ico-chat.svg";
import IcoCoinSvg from "./outline/ico-coin.svg";
import IcoCopySvg from "./outline/ico-copy.svg";
import IcoDotsSvg from "./outline/ico-dots.svg";
import IcoHomeSvg from "./outline/ico-home.svg";
import IcoInfoSvg from "./outline/ico-info.svg";
import IcoLinkSvg from "./outline/ico-link.svg";
import IcoListSvg from "./outline/ico-list.svg";
import IcoPlusSvg from "./outline/ico-plus.svg";
import IcoPrevSvg from "./outline/ico-prev.svg";
import IcoSpotSvg from "./outline/ico-spot.svg";
import IcoAlarmSvg from "./outline/ico-alarm.svg";
import IcoCaretSvg from "./outline/ico-caret.svg";
import IcoCheckSvg from "./outline/ico-check.svg";
import IcoCloseSvg from "./outline/ico-close.svg";
import IcoMinusSvg from "./outline/ico-minus.svg";
import IcoPhoneSvg from "./outline/ico-phone.svg";
import IcoPencilSvg from "./outline/ico-pencil.svg";
import IcoSearchSvg from "./outline/ico-search.svg";
import IcoHistorySvg from "./outline/ico-history.svg";
import IcoRefreshSvg from "./outline/ico-refresh.svg";
import IcoArrowUpSvg from "./outline/ico-arrow-up.svg";
import IcoCalendarSvg from "./outline/ico-calendar.svg";
import IcoDownloadSvg from "./outline/ico-download.svg";
import IcoEstimateSvg from "./outline/ico-estimate.svg";
import IcoLineTwoSvg from "./outline/ico-line-two.svg";
import IcoQuestionSvg from "./outline/ico-question.svg";
import IcoTrashCanSvg from "./outline/ico-trash-can.svg";
import IcoArrowDownSvg from "./outline/ico-arrow-down.svg";
import IcoArrowLeftSvg from "./outline/ico-arrow-left.svg";
import IcoArrowRightSvg from "./outline/ico-arrow-right.svg";
import IcoPaperPlaneSvg from "./outline/ico-paper-plane.svg";
import IcoCashWithArrowSvg from "./outline/ico-cash-with-arrow.svg";
import IcoCircleQuestionSvg from "./outline/ico-circle-question.svg";
import IcoDoubleArrowLeftSvg from "./outline/ico-double-arrow-left.svg";
import IcoDoubleArrowRightSvg from "./outline/ico-double-arrow-right.svg";

var icoAlarm = IcoAlarmSvg;

var icoCar = IcoCarSvg;

var icoDots = IcoDotsSvg;

var icoPlus = IcoPlusSvg;

var icoSpot = IcoSpotSvg;

var icoCaret = IcoCaretSvg;

var icoHistory = IcoHistorySvg;

var icoPrev = IcoPrevSvg;

var icoChat = IcoChatSvg;

var icoHome = IcoHomeSvg;

var icoQuestion = IcoQuestionSvg;

var icoCheck = IcoCheckSvg;

var icoInfo = IcoInfoSvg;

var icoRefresh = IcoRefreshSvg;

var icoClose = IcoCloseSvg;

var icoLineTwo = IcoLineTwoSvg;

var icoSearch = IcoSearchSvg;

var icoArrowDown = IcoArrowDownSvg;

var icoArrowLeft = IcoArrowLeftSvg;

var icoArrowRight = IcoArrowRightSvg;

var icoArrowUp = IcoArrowUpSvg;

var icoPhone = IcoPhoneSvg;

var icoCopy = IcoCopySvg;

var icoMinus = IcoMinusSvg;

var icoDoubleArrowLeft = IcoDoubleArrowLeftSvg;

var icoDoubleArrowRight = IcoDoubleArrowRightSvg;

var icoCalendar = IcoCalendarSvg;

var icoPencil = IcoPencilSvg;

var icoTrashCan = IcoTrashCanSvg;

var icoPaperPlane = IcoPaperPlaneSvg;

var icoCircleQuestion = IcoCircleQuestionSvg;

var icoCashWithArrow = IcoCashWithArrowSvg;

var icoList = IcoListSvg;

var icoDownload = IcoDownloadSvg;

var icoEstimate = IcoEstimateSvg;

var icoCoin = IcoCoinSvg;

var icoLink = IcoLinkSvg;

function convert(t) {
  if (t === "ico-pencil") {
    return icoPencil;
  } else if (t === "ico-alarm") {
    return icoAlarm;
  } else if (t === "ico-download") {
    return icoDownload;
  } else if (t === "ico-circle-question") {
    return icoCircleQuestion;
  } else if (t === "ico-cash-with-arrow") {
    return icoCashWithArrow;
  } else if (t === "ico-question") {
    return icoQuestion;
  } else if (t === "ico-caret") {
    return icoCaret;
  } else if (t === "ico-phone") {
    return icoPhone;
  } else if (t === "ico-check") {
    return icoCheck;
  } else if (t === "ico-search") {
    return icoSearch;
  } else if (t === "ico-close") {
    return icoClose;
  } else if (t === "ico-trash-can") {
    return icoTrashCan;
  } else if (t === "ico-arrow-down") {
    return icoArrowDown;
  } else if (t === "ico-arrow-left") {
    return icoArrowLeft;
  } else if (t === "ico-paper-plane") {
    return icoPaperPlane;
  } else if (t === "ico-chat") {
    return icoChat;
  } else if (t === "ico-coin") {
    return icoCoin;
  } else if (t === "ico-copy") {
    return icoCopy;
  } else if (t === "ico-dots") {
    return icoDots;
  } else if (t === "ico-home") {
    return icoHome;
  } else if (t === "ico-info") {
    return icoInfo;
  } else if (t === "ico-link") {
    return icoLink;
  } else if (t === "ico-list") {
    return icoList;
  } else if (t === "ico-double-arrow-left") {
    return icoDoubleArrowLeft;
  } else if (t === "ico-arrow-right") {
    return icoArrowRight;
  } else if (t === "ico-plus") {
    return icoPlus;
  } else if (t === "ico-prev") {
    return icoPrev;
  } else if (t === "ico-estimate") {
    return icoEstimate;
  } else if (t === "ico-history") {
    return icoHistory;
  } else if (t === "ico-spot") {
    return icoSpot;
  } else if (t === "ico-refresh") {
    return icoRefresh;
  } else if (t === "ico-car") {
    return icoCar;
  } else if (t === "ico-double-arrow-right") {
    return icoDoubleArrowRight;
  } else if (t === "ico-minus") {
    return icoMinus;
  } else if (t === "ico-line-two") {
    return icoLineTwo;
  } else if (t === "ico-arrow-up") {
    return icoArrowUp;
  } else {
    return icoCalendar;
  }
}

function CDS_Icon_Outline(props) {
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  return React.createElement(convert(props.name), {
              className: TailwindMerge.twMerge("w-6 h-6 text-blue-gray-900", className),
              style: props.style,
              height: "24",
              width: "24"
            });
}

var make = CDS_Icon_Outline;

export {
  icoAlarm ,
  icoCar ,
  icoDots ,
  icoPlus ,
  icoSpot ,
  icoCaret ,
  icoHistory ,
  icoPrev ,
  icoChat ,
  icoHome ,
  icoQuestion ,
  icoCheck ,
  icoInfo ,
  icoRefresh ,
  icoClose ,
  icoLineTwo ,
  icoSearch ,
  icoArrowDown ,
  icoArrowLeft ,
  icoArrowRight ,
  icoArrowUp ,
  icoPhone ,
  icoCopy ,
  icoMinus ,
  icoDoubleArrowLeft ,
  icoDoubleArrowRight ,
  icoCalendar ,
  icoPencil ,
  icoTrashCan ,
  icoPaperPlane ,
  icoCircleQuestion ,
  icoCashWithArrow ,
  icoList ,
  icoDownload ,
  icoEstimate ,
  icoCoin ,
  icoLink ,
  convert ,
  make ,
}
/* icoAlarm Not a pure module */
